import { SVGProps, Ref, forwardRef } from 'react';

export const SendWebOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.595 22.554c-.98.949-3.03.283-7.129-1.047l-1.459-.473c-.993-.323-1.49-.484-2.007-.484s-1.014.161-2.007.484l-1.46.473c-4.099 1.33-6.149 1.996-7.128 1.047-.978-.95-.094-2.744 1.676-6.333L8.021 6.2C9.732 2.733 10.586 1 12 1s2.27 1.733 3.978 5.2l4.94 10.02c1.77 3.59 2.655 5.385 1.677 6.334M9.636 6.996l-4.94 10.02c-.915 1.855-1.498 3.05-1.767 3.902q-.05.164-.079.279a5 5 0 0 0 .62-.081c1.003-.188 2.406-.639 4.508-1.321l1.786-.58L12 9.378l2.236 9.837 1.786.58c2.102.682 3.505 1.133 4.509 1.32.275.052.476.074.619.082a5 5 0 0 0-.08-.279c-.268-.851-.851-2.047-1.765-3.901L14.364 6.996c-.883-1.79-1.455-2.94-1.962-3.667A3 3 0 0 0 12 2.843c-.08.072-.212.214-.402.486-.507.728-1.08 1.877-1.962 3.667"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendWebOutlinedSize24Glyph.displayName = 'SendWebOutlinedSize24Glyph';
